import React, { FC } from "react";
import { Button } from "antd";
import { Task } from "../../data-types";
import { Icons } from "../vpd-icons/icons";
import styles from "./task-row.module.css";
import { VpdInlineEditor } from "../tiny-text-editor/vpd-inline";
import { TimelineIndicator } from "../timeline-indicator/timeline-indicator";

const { ["task-container"]: taskContainerClassname, ["name-input"]: nameInputClassname } =
  styles as any;

type Props = {
  task: Task;
  onUpdate: (task: Partial<Task>) => void;
  onDelete: (id: number) => void;
  prefix?: React.ReactNode;
  defaultFont: string;
  onTimelineEdit: (context: {
    id: number;
    title: string;
    startDate?: Date | null;
    deadlineDate?: Date | null;
  }) => void;
};

export const TaskRow: FC<Props> = ({
  task: { id, title, html, startDate, deadlineDate },
  onUpdate,
  onDelete,
  prefix,
  defaultFont,
  onTimelineEdit,
}) => {
  return (
    <div className={taskContainerClassname}>
      {prefix}
      <div className={nameInputClassname}>
        <VpdInlineEditor
          key={`task-${id}`}
          defaultFont={defaultFont}
          initialValue={html ?? title}
          onBlur={(e) => {
            const newHtmlContent = e.target.getContent();
            const newTextContent = e.target.getContent({ format: "text" });

            if (newHtmlContent !== (html ?? title)) {
              onUpdate({
                id,
                title: newTextContent,
                html: newHtmlContent,
              });
            }
          }}
        />
      </div>
      <TimelineIndicator
        size="small"
        isComplete={!!startDate && !!deadlineDate}
        startDate={startDate}
        deadlineDate={deadlineDate}
        onClick={(e) => {
          e.stopPropagation();
          onTimelineEdit({ id, title, startDate, deadlineDate });
        }}
      />
      <Button
        size="small"
        shape="circle"
        icon={Icons.Delete}
        type="link"
        onClick={() => onDelete(id)}
      />
    </div>
  );
};
